/* section-main-collection-product-grid.js — plan 009-4c (2026-07-10)
   Script filtres/drawer mobile, ex-inline (100 % statique) en fin de
   sections/main-collection-product-grid.liquid, externalisé verbatim pour
   cache CDN et chargé defer au même endroit. Auto-gardé par
   window.__acFiltersInit ; ne consomme aucune globale d'un autre script
   (vérifié : repo + HTML rendu). */
  (function () {
    if (window.__acFiltersInit) return;
    window.__acFiltersInit = true;

    function closeDrawerSilently() {
      var details = document.querySelector('#main-collection-filters details.mobile-facets__disclosure');
      if (details && details.hasAttribute('open')) {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      }
    }
    setTimeout(closeDrawerSilently, 80);
    /* ── Injecter bouton X dans le header du drawer ── */
    function injectCloseBtn() {
      var header = document.querySelector('#main-collection-filters .mobile-facets__header');
      if (!header || header.querySelector('.ac-close-btn')) return;
      var btn = document.createElement('button');
      btn.className = 'ac-close-btn';
      btn.type = 'button';
      btn.setAttribute('aria-label', 'Fermer');
      btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 18 17" fill="none"><path fill="currentColor" d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"/></svg>';
      btn.addEventListener('click', function() {
        var summary = document.querySelector('#main-collection-filters summary.mobile-facets__open-wrapper');
        if (summary) summary.click();
      });
      header.appendChild(btn);
    }

    /* Injecter dès l'ouverture */
    var drawerDetails = document.querySelector('#main-collection-filters details');
    if (drawerDetails) {
      new MutationObserver(function() { setTimeout(injectCloseBtn, 60); })
        .observe(drawerDetails, { attributes: true, attributeFilter: ['open'] });
    }


    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-open-filters]');
      if (!btn) return;
      var summary = document.querySelector('#main-collection-filters summary.mobile-facets__open-wrapper');
      if (!summary) return;
      summary.click();
    });

    document.addEventListener('change', function (e) {
      var checkbox = e.target.closest('#FacetFiltersFormMobile input[type="checkbox"], #FacetFiltersFormMobile input[type="radio"]');
      if (!checkbox) return;
      clearTimeout(window.__acFilterTimeout);
      window.__acFilterTimeout = setTimeout(function () {
        var form = document.getElementById('FacetFiltersFormMobile');
        if (!form) return;
        var params = new URLSearchParams(new FormData(form)).toString();
        var sectionId = document.getElementById('main-collection-filters') && document.getElementById('main-collection-filters').dataset.id;
        if (!sectionId) return;
        var url = window.location.pathname + '?section_id=' + sectionId + '&' + params;
        fetch(url)
          .then(function(r){ return r.text(); })
          .then(function(html){
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            var newGrid = doc.getElementById('ProductGridContainer');
            var curGrid = document.getElementById('ProductGridContainer');
            if (newGrid && curGrid) curGrid.innerHTML = newGrid.innerHTML;
            var newFilters = doc.getElementById('main-collection-filters');
            var curFilters = document.getElementById('main-collection-filters');
            if (newFilters && curFilters) curFilters.innerHTML = newFilters.innerHTML;
            setTimeout(closeDrawerSilently, 50);
            var filterParams = new URLSearchParams(params);
            filterParams.delete('section_id');
            var newUrl = window.location.pathname + (filterParams.toString() ? '?' + filterParams.toString() : '');
            history.replaceState({}, '', newUrl);
          })
          .catch(function(){});
      }, 2000);
    }, true);

  })();
